import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { allSharedComponents } from "../../../../../shared";
import { useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Button, Container, Col, Form, Row } from "react-bootstrap";
import {
  SpotActions,
  competitionActions,
  boatTypeActions,
  authActions,
} from "../../../../../redux/actions";
import {
  convertObjectToFormData,
  mergeDateTimeToServerFormat,
  serverFormatToDateObject,
  UTCWithTimezoneToISOString,
  replaceLocalToUTCFormatZ,
} from "../../../../../system";
import {
  modeConstants,
  sportConstants,
  Directions,
  translationConstants,
  competitionProvidedServices,
  competitionsStatusEnum,
  competitionConstants,
  viewPathConstants,
  fieldLengthConstants,
  globalConstants,
  competitionAllowedUsers,
  EVENT_STATUS,
  timezoneConstants,
  levelEnum,
  levelEnumReversed,
  genderEnumReversed,
  genderEnum,
  spotConstants,
} from "../../../../../constants";
import { genderOptions, LocationSelectionConstants } from "../utilities";
import FindOnMapModal from "../../../../../shared/components/Modals/FindOnMapModal";

const AddCompetitions = () => {
  const { Mandatory_Character } = globalConstants;

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const mode = location?.state?.modeType;
  const competitionId = location?.state?.competitionId;

  const {
    FileUploader,
    ReactDatePickerWrapper,
    InputFieldWrapper,
    MultiSelect,
    CustomModal,
    ConfirmationModal,
  } = allSharedComponents;

  const {
    setValue,
    getValues,
    register,
    handleSubmit,
    trigger,
    watch,
    clearErrors,
    control,
    formState: { errors },
  } = useForm();

  const cities = useSelector((state) => state.LoginReducer.cities);
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  const Classes = useSelector(
    (state) => state.BoatTypeReducer.genderBoatClassData.data
  );
  const competitionDataById = useSelector(
    (state) => state.CompetitionReducer.competitionDataById
  );
  const spots = useSelector(
    (state) => state.SpotsReducer.allApprovedPublicPrivateSpots
  );

  const [title, setTitle] = useState("");
  const [messageLine1, setMessageLine1] = useState("");
  const [messageLine2, setMessageLine2] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState();
  const [isPublicRegistrationAllowed, setIsPublicRegistrationAllowed] =
    useState(true);
  const [isExclusiveForMembers, setIsExclusiveForMembers] = useState(false);
  const [isRegistrationFees, setIsRegistrationFees] = useState(true);
  const [isSpecialMemberFeeEnable, setIsSpecialMemberFeeEnable] =
    useState(false);
  const [isNorUpdated, setIsNorUpdated] = useState(false);
  const [isLogoUpdated, setIsLogoUpdated] = useState(false);
  const [isPostersUpdated, setIsPostersUpdated] = useState(false);
  const [isDateChanged, setIsDateChanged] = useState(false);
  const [isLocationChanged, setIsLocationChanged] = useState(false);
  const [nor, setNor] = useState([]);
  const [posters, setPosters] = useState([]);
  const [logo, setLogo] = useState([]);
  const [norValidationMessage, setNORValidationMessage] = useState("");
  const [postersValidationMessage, setPostersValidationMessage] = useState("");
  const [logoValidationMessage, setLogoValidationMessage] = useState("");
  const [modalEvent, setModalEvent] = useState({});
  const [modalData, setModalData] = useState({});

  const [isShowMap, setShowMap] = useState(false);
  const [lng, setLng] = useState("");
  const [lat, setLat] = useState("");
  const [selectedSpotType, setSelectedSpotType] = useState(
    LocationSelectionConstants.PUBLIC_SPOT
  );

  const [selectedServices, setSelectedServices] = useState({
    LEAVE_LETTER: false,
    MEALS: false,
    FLIGHTS: false,
    RENTED_BOATS: false,
    ACCOMMODATION: false,
    SNACKS_AND_WATER: false,
    BOATS_FOR_PARTICIPANTS: false,
  });

  const backToCompetition = () => {
    navigate(viewPathConstants.COMPETITIONS);
  };

  const dateLocationHandler = (data, event) => {
    setTitle(
      isLocationChanged || isDateChanged
        ? `${t(translationConstants.CHANGE)} ${
            (isDateChanged &&
              !isLocationChanged &&
              t(translationConstants.DATES)) ||
            (isLocationChanged &&
              !isDateChanged &&
              t(translationConstants.COMPETITION_LOCATION)) ||
            (isDateChanged &&
              isLocationChanged &&
              t(translationConstants.COMPETITION_LOCAITON_AND_DATE))
          }`
        : t(translationConstants.CONFIRMATION)
    );
    setMessageLine1(
      isLocationChanged || isDateChanged
        ? `${t(translationConstants.ARE_YOU_SURE_YOU_WANT_TO_CHANGE_THE)} ${
            (isDateChanged &&
              !isLocationChanged &&
              t(translationConstants.DATES)) ||
            (isLocationChanged &&
              !isDateChanged &&
              t(translationConstants.COMPETITION_LOCATION)) ||
            (isDateChanged &&
              isLocationChanged &&
              t(translationConstants.COMPETITION_LOCAITON_AND_DATE))
          }?`
        : ""
    );
    setMessageLine2(
      isLocationChanged || isDateChanged
        ? t(translationConstants.EMAIL_TO_ALL_PARTICIPANTS)
        : t(translationConstants.are_you_sure_you_want_to_update)
    );
    if (
      !(competitionDataById?.competitionInfo?.status === EVENT_STATUS.Draft) &&
      !(
        event?.nativeEvent?.submitter?.id ===
          competitionConstants.UNPUBLISH_BUTTON ||
        event?.nativeEvent?.submitter?.id ===
          competitionConstants.PUBLISH_BUTTON
      )
    ) {
      setModalData(data);
      setModalEvent(event);
      setModalOpen(!isModalOpen);
    } else {
      onSubmit(data, event);
    }
  };

  const onSubmit = (data, event) => {
    const { endTime, startTime, userAllowed, ...removedTime } = data;
    const buttonId = event?.nativeEvent?.submitter?.id;
    const selectedServicesString = createSelectedServicesString();

    const dataToSend = {
      CompetitionInfo: {
        ...removedTime.CompetitionInfo,
        SpecialMemberFee: isSpecialMemberFeeEnable
          ? removedTime.CompetitionInfo.SpecialMemberFee
          : null,
        ProvidedServices: selectedServicesString,
        startDateString: mergeDateTimeToServerFormat(
          removedTime.CompetitionInfo.StartDateString,
          startTime
        ),
        endDateString: mergeDateTimeToServerFormat(
          removedTime.CompetitionInfo.EndDateString,
          endTime ? endTime : moment().set(timezoneConstants.twelvePM).toDate()
        ),
        RegistrationStartDateString: mergeDateTimeToServerFormat(
          data.CompetitionInfo.RegistrationStartDateString,
          moment().set(timezoneConstants.twelveAM).toDate()
        ),
        RegistrationEndDateString: mergeDateTimeToServerFormat(
          data.CompetitionInfo.RegistrationEndDateString,
          moment().set(timezoneConstants.twelvePM).toDate()
        ),
        IsVerifiedUserAllowed: userAllowed.includes(
          competitionConstants.VERIFIED_USER
        ),
        IsPractionerAllowed: userAllowed.includes(
          competitionConstants.PRACTITIONER
        ),
        LocationURL:
          removedTime.CompetitionInfo.LocationURL === undefined
            ? null
            : removedTime.CompetitionInfo.LocationURL,
        Lat:
          removedTime.CompetitionInfo.Lat === undefined
            ? null
            : removedTime.CompetitionInfo.Lat,
        Long:
          removedTime.CompetitionInfo.Long === undefined
            ? null
            : removedTime.CompetitionInfo.Long,
      },
      nor: data?.nor ? data?.nor[0] : null,
      posters: data?.posters ? data?.posters[0] : null,
      logo: data?.logo ? data?.logo[0] : null,
      Classes: data?.Classes,
    };

    const formData = convertObjectToFormData(dataToSend);
    if (mode === modeConstants.ADD_MODE) {
      if (buttonId === competitionConstants.ADD_BUTTON) {
        formData.append(
          "CompetitionInfo.Status",
          competitionsStatusEnum.PUBLISHED
        );
        dispatch(
          competitionActions.addCompetition(formData, backToCompetition)
        );
      } else if (buttonId === competitionConstants.DRAFT_BUTTON) {
        formData.append("CompetitionInfo.status", competitionsStatusEnum.DRAFT);
        dispatch(
          competitionActions.addCompetition(formData, backToCompetition)
        );
      }
    } else if (mode === modeConstants.EDIT_MODE) {
      if (buttonId === competitionConstants.UPDATE_BUTTON) {
        formData.append("id", competitionDataById?.id);
        formData.append(
          "CompetitionInfo.Status",
          competitionDataById?.competitionInfo?.status
        );
        formData.append("isNorUpdated", isNorUpdated);
        formData.append("isPostersUpdated", isPostersUpdated);
        formData.append("isLogoUpdated", isLogoUpdated);
        dispatch(
          competitionActions.updateCompetition(formData, backToCompetition)
        );
        dispatch(competitionActions.toggleViewMode(false));
      }
    }
  };

  useEffect(() => {
    if (
      (mode === modeConstants.VIEW_MODE || mode === modeConstants.EDIT_MODE) &&
      competitionDataById
    ) {
      setValue(
        "CompetitionInfo.Title",
        competitionDataById?.competitionInfo?.title
      );
      setValue(
        "CompetitionInfo.ArabicTitle",
        competitionDataById?.competitionInfo?.arabicTitle
      );
      setValue(
        "CompetitionInfo.Description",
        competitionDataById?.competitionInfo?.description
      );
      setValue(
        "CompetitionInfo.ArabicDescription",
        competitionDataById?.competitionInfo?.arabicDescription
      );
      setValue(
        "CompetitionInfo.Gender",
        competitionDataById?.competitionInfo?.gender
      );
      // ----------------------------------------------------------------
      setValue(
        "CompetitionInfo.IsPublicRegistrationAllowed",
        competitionDataById?.competitionInfo?.isPublicRegistrationAllowed
      );
      competitionDataById?.competitionInfo?.isPublicRegistrationAllowed === true
        ? setIsPublicRegistrationAllowed(true)
        : setIsPublicRegistrationAllowed(false);
      // ----------------------------------------------------------------
      setValue(
        "CompetitionInfo.IsMemebersExclusiveOnly",
        competitionDataById?.competitionInfo?.isMemebersExclusiveOnly
      );
      competitionDataById?.competitionInfo?.isMemebersExclusiveOnly === true
        ? setIsExclusiveForMembers(true)
        : setIsExclusiveForMembers(false);
      // ----------------------------------------------------------------
      setValue(
        "CompetitionInfo.StartDateString",
        serverFormatToDateObject(
          competitionDataById?.competitionInfo?.startDateString
        )
      );
      setValue(
        "startTime",
        serverFormatToDateObject(
          competitionDataById?.competitionInfo?.startDateString
        )
      );
      setValue(
        "CompetitionInfo.EndDateString",
        serverFormatToDateObject(
          competitionDataById?.competitionInfo?.endDateString
        )
      );
      setValue(
        "endTime",
        serverFormatToDateObject(
          competitionDataById?.competitionInfo?.endDateString
        )
      );
      setValue(
        "CompetitionInfo.RegistrationStartDateString",
        serverFormatToDateObject(
          competitionDataById?.competitionInfo?.registrationStartDateString
        )
      );
      setValue(
        "CompetitionInfo.RegistrationEndDateString",
        serverFormatToDateObject(
          competitionDataById?.competitionInfo?.registrationEndDateString
        )
      );
      setValue(
        "CompetitionInfo.SportId",
        competitionDataById?.competitionInfo?.sportId
      );
      //----------------------------------------------------------------
      const filterOptions = getFilteredBoatClassOptions(
        Classes,
        competitionDataById?.competitionInfo?.sportId,
        competitionDataById?.competitionInfo?.gender,
        direction
      )?.filter((option) =>
        competitionDataById?.classes?.find((data) => data.id === option.value)
      );
      const serverSelectedBoatTypes = filterOptions?.map(
        (option) => option.value
      );
      setValue("Classes", serverSelectedBoatTypes);
      trigger("Classes");
      setSelectedOptions(filterOptions);
      //----------------------------------------------------------------
      competitionDataById?.competitionInfo?.registrationFee === null
        ? setIsRegistrationFees(false)
        : setIsRegistrationFees(true);
      competitionDataById?.competitionInfo?.specialMemberFee === null
        ? setIsSpecialMemberFeeEnable(false)
        : setIsSpecialMemberFeeEnable(true);
      // ----------------------------------------------------------------
      setValue(
        "CompetitionInfo.RegistrationFee",
        competitionDataById?.competitionInfo?.registrationFee
      );
      setValue(
        "CompetitionInfo.SpecialMemberFee",
        competitionDataById?.competitionInfo?.specialMemberFee
      );
      setValue(
        "CompetitionInfo.AllowedLevel",
        competitionDataById?.competitionInfo?.allowedLevel
      );
      // ----------------------------------------------------------------
      setValue(
        "CompetitionInfo.MaximumParticipantsAllowed",
        competitionDataById?.competitionInfo?.maximumParticipantsAllowed
      );
      // ----------------------------------------------------------------
      const userAllowed = [];
      if (competitionDataById?.competitionInfo?.isVerifiedUserAllowed) {
        userAllowed.push(competitionConstants.VERIFIED_USER);
      }
      if (competitionDataById?.competitionInfo?.isPractionerAllowed) {
        userAllowed.push(competitionConstants.PRACTITIONER);
      }
      setValue("userAllowed", userAllowed);
      // ----------------------------------------------------------------
      setValue(
        "CompetitionInfo.MinAge",
        competitionDataById?.competitionInfo?.minAge
      );
      setValue(
        "CompetitionInfo.MaxAge",
        competitionDataById?.competitionInfo?.maxAge
      );
      if (competitionDataById?.competitionInfo?.providedServices != null) {
        const servicesFromServer =
          competitionDataById.competitionInfo.providedServices.split(", ");
        const servicesToUpdate = servicesFromServer.reduce((acc, service) => {
          const key = reverseProvidedServices[service];
          if (key) {
            acc[key] = true;
          }
          return acc;
        }, {});
        setSelectedServices((prevState) => ({
          ...prevState,
          ...servicesToUpdate,
        }));
      } else {
        setSelectedServices(false);
      }
      // ----------------------------------------------------------------
      competitionDataById?.logo
        ? setLogo([competitionDataById.logo])
        : setLogo([]);
      competitionDataById?.nor ? setNor([competitionDataById.nor]) : setNor([]);
      competitionDataById?.posters
        ? setPosters([competitionDataById.posters])
        : setPosters([]);

      competitionDataById?.CityId &&
        setValue("CompetitionInfo.CityId", competitionDataById?.CityId);

      if (
        competitionDataById?.competitionInfo?.lat &&
        competitionDataById?.competitionInfo?.long &&
        competitionDataById?.competitionInfo?.cityId
      ) {
        setSelectedSpotType(LocationSelectionConstants.CUSTOM_LOCATION);
        setValue(
          "CompetitionInfo.Lat",
          competitionDataById?.competitionInfo?.lat
        );
        setValue(
          "CompetitionInfo.Long",
          competitionDataById?.competitionInfo?.long
        );
        setValue(
          "CompetitionInfo.CityId",
          competitionDataById?.competitionInfo?.cityId
        );
      }

      if (competitionDataById?.competitionInfo?.spotId) {
        const selectedSpot = spots?.data?.find(
          (spot) => spot.id === competitionDataById.competitionInfo.spotId
        );
        if (selectedSpot) {
          let spotType;
          if (
            selectedSpot.spotTypeId === LocationSelectionConstants.PUBLIC_SPOT
          ) {
            spotType = LocationSelectionConstants.PUBLIC_SPOT;
          } else if (
            selectedSpot.spotTypeId === LocationSelectionConstants.PRIVATE_SPOT
          ) {
            spotType = LocationSelectionConstants.PRIVATE_SPOT;
          } else {
            spotType = LocationSelectionConstants.CUSTOM_LOCATION;
          }
          setSelectedSpotType(spotType);
          setValue(
            "CompetitionInfo.SpotId",
            competitionDataById.competitionInfo.spotId
          );
          handleLocationChange(competitionDataById.competitionInfo.spotId);
          trigger("CompetitionInfo.SpotId");
        } else {
          setSelectedSpotType(LocationSelectionConstants.CUSTOM_LOCATION);
        }
      }
    }
    //eslint-disable-next-line
  }, [dispatch, Classes, competitionDataById]);

  useEffect(() => {
    if (mode === modeConstants.EDIT_MODE) {
      dispatch(competitionActions.getCompetitionById(competitionId));
    }
    dispatch(SpotActions.getAllApprovedSpots());
    dispatch(boatTypeActions.getAllGenderBoatClass());
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));
    //eslint-disable-next-line
  }, []);

  const generateGoogleMapsLink = (Lat, Long) => {
    return `https://www.google.com/maps/search/?api=1&query=${Lat},${Long}`;
  };

  const handleLocationChange = (eventOrValue) => {
    let selectedId = eventOrValue;
    if (typeof eventOrValue === "object") {
      selectedId = eventOrValue.target.value;
    }
    const selectedLocation = spots?.data?.find(
      (location) => location.id === selectedId
    );
    if (selectedLocation) {
      const newMapsLink = generateGoogleMapsLink(
        selectedLocation.lat,
        selectedLocation.long
      );
      setValue("CompetitionInfo.LocationURL", newMapsLink);
      setValue("CompetitionInfo.SpotId", selectedId);
      trigger("CompetitionInfo.SpotId");
    }
  };

  const isCompetitionEndTimeAfterStartTimeIfSameDay = (endTime) => {
    const startDate = getValues("CompetitionInfo.StartDateString");
    const endDate = getValues("CompetitionInfo.EndDateString");
    const startTime = getValues("startTime");
    return (
      !endTime ||
      !replaceLocalToUTCFormatZ(endDate).isSame(
        replaceLocalToUTCFormatZ(startDate),
        "day"
      ) ||
      replaceLocalToUTCFormatZ(endTime).isAfter(
        replaceLocalToUTCFormatZ(startTime)
      ) ||
      t(translationConstants.CENTER_END_TIME_NOT_BEFORE_START_TIME)
    );
  };

  const isBefore = (value, field) => {
    return replaceLocalToUTCFormatZ(value).isBefore(
      replaceLocalToUTCFormatZ(getValues(field)),
      "day"
    );
  };

  const isSameOrAfter = (value, field) => {
    return replaceLocalToUTCFormatZ(value).isSameOrAfter(
      replaceLocalToUTCFormatZ(getValues(field)),
      "day"
    );
  };

  const handleCheckboxChange = (id) => {
    setSelectedServices((prevSelected) => ({
      ...prevSelected,
      [id]: !prevSelected[id],
    }));
  };

  const createSelectedServicesString = () => {
    const selectedServiceKeys = Object.keys(selectedServices).filter(
      (key) => selectedServices[key]
    );
    const selectedServiceValues = selectedServiceKeys?.map(
      (key) => competitionProvidedServices[key]
    );
    return selectedServiceValues.join(", ");
  };

  const handleFileUpload = useCallback(
    (file, key) => {
      setValue(key, file, { shouldValidate: true });
    },
    [setValue]
  );

  const reverseProvidedServices = Object.entries(
    competitionProvidedServices
  ).reduce((acc, [key, value]) => {
    acc[value] = key;
    return acc;
  }, {});

  const disableDates = (withOneDay) => {
    if (withOneDay) {
      return new Date(UTCWithTimezoneToISOString(1));
    } else return new Date(UTCWithTimezoneToISOString());
  };

  const handleLocationCheckboxChange = (checkboxId) => {
    setSelectedSpotType(checkboxId);
    setValue("CompetitionInfo.CityId", "");
    if (checkboxId !== LocationSelectionConstants.CUSTOM_LOCATION) {
      clearErrors("CompetitionInfo.Lat");
      clearErrors("CompetitionInfo.Long");
      setValue("CompetitionInfo.CityId", null);
    }
  };

  const onSetShowMap = () => {
    const latitude = getValues("CompetitionInfo.Lat");
    const longitude = getValues("CompetitionInfo.Long");
    setLat(latitude);
    setLng(longitude);
    setShowMap((prev) => !prev);
  };

  const handleSaveLocation = () => {
    setValue("CompetitionInfo.Lat", lat);
    setValue("CompetitionInfo.Long", lng);
    trigger("CompetitionInfo.Lat");
    trigger("CompetitionInfo.Long");
    setShowMap(false);
  };

  const getFilteredBoatClassOptions = (
    boatClasses,
    sportId,
    gender,
    direction
  ) => {
    return (
      boatClasses
        ?.filter(
          (object) =>
            object.sportId === Number(sportId) &&
            (Number(gender) === genderEnum.MIXED ||
              object.gender === Number(gender))
        )
        ?.map((object) => {
          const translatedGender = t(
            translationConstants[genderEnumReversed[object.gender]]
          );
          const name =
            direction === Directions.rtl && object.arabicName
              ? object.arabicName
              : object.name;
          return {
            label: `${name} - ${translatedGender}`,
            value: object.id,
          };
        }) || []
    );
  };

  const selectedSportId = watch("CompetitionInfo.SportId");
  const selectedGender = watch("CompetitionInfo.Gender");

  const filteredOptions = useMemo(() => {
    const options = getFilteredBoatClassOptions(
      Classes,
      selectedSportId,
      selectedGender,
      direction
    );
    const updatedSelectedOptions = options.filter((option) =>
      selectedOptions.some((selected) => selected.value === option.value)
    );
    setSelectedOptions(updatedSelectedOptions);
    return options;
  }, [selectedSportId, selectedGender, direction, t, Classes]);

  const getFilteredSpotsOptions = (spotType) =>
    spots?.data
      ?.filter((spot) => spot.spotTypeId === spotType)
      ?.map((spot) => (
        <option key={spot.id} value={spot.id}>
          {direction === Directions.rtl
            ? spot?.arabicName || spot?.name
            : spot?.name}
        </option>
      ));

  return (
    <div className="UserDiv competition-form">
      <p className="UserTabHeading">
        {mode === modeConstants.EDIT_MODE
          ? t(translationConstants.EDIT_A_COMPETITION)
          : mode === modeConstants.ADD_MODE
          ? t(translationConstants.CREATE_A_COMPETITION)
          : t(translationConstants.VIEW_A_COMPETITION)}
      </p>
      <Row className="m-t-24">
        <Col md={10}>
          <Form
            noValidate
            className="ViewUserContent"
            onSubmit={
              mode === modeConstants.ADD_MODE
                ? handleSubmit(onSubmit)
                : handleSubmit(dateLocationHandler)
            }
          >
            <Container>
              <Row>
                <InputFieldWrapper
                  label={
                    `${t(translationConstants.COMPETITION_TITLE)}:` +
                    Mandatory_Character
                  }
                >
                  <Form.Control
                    type="text"
                    id="CompetitionInfo.Title"
                    disabled={mode === modeConstants.VIEW_MODE}
                    placeholder={t(
                      translationConstants.ENTER_COMPETITION_TITLE
                    )}
                    {...register("CompetitionInfo.Title", {
                      required: t(
                        translationConstants.COMPETITION_TITLE_REQUIRED
                      ),
                      maxLength: {
                        value:
                          fieldLengthConstants.EVENT_COMPETITION_NAME_FIELD_LENGTH,
                        message: t(
                          translationConstants.COMPETITION_TITLE_TOO_LONG
                        ),
                      },
                      pattern: {
                        value:
                          /^[A-Za-z0-9\s!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/i,
                        message: t(
                          translationConstants.INVALID_COMETITION_TITLE
                        ),
                      },
                    })}
                  />
                  {errors?.CompetitionInfo?.Title && (
                    <p className="errorText">
                      {errors?.CompetitionInfo?.Title.message}
                    </p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  label={
                    <>
                      {t(translationConstants.COMPETITION_TITLE)}{" "}
                      {t(translationConstants.ARABIC_WITH_BRACES)}:
                      <span className="greenText">
                        {" "}
                        ({t(translationConstants.optional)})
                      </span>
                    </>
                  }
                >
                  <Form.Control
                    id="CompetitionInfo.ArabicTitle"
                    dir={Directions.rtl}
                    type="text"
                    disabled={mode === modeConstants.VIEW_MODE}
                    placeholder="أدخل العنوان باللغة العربية"
                    {...register("CompetitionInfo.ArabicTitle", {
                      maxLength: {
                        value:
                          fieldLengthConstants.EVENT_COMPETITION_NAME_FIELD_LENGTH,
                        message: t(
                          translationConstants.COMPETITION_ARABIC_TITLE_TOO_LONG
                        ),
                      },
                    })}
                  />
                  {errors?.CompetitionInfo?.ArabicTitle && (
                    <p className="errorText">
                      {errors?.CompetitionInfo?.ArabicTitle.message}
                    </p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  md={12}
                  label={
                    <>
                      {t(translationConstants.DESCRIPTION)}:
                      {Mandatory_Character}
                    </>
                  }
                >
                  <Form.Control
                    type="text"
                    id="CompetitionInfo.Description"
                    as="textarea"
                    disabled={mode === modeConstants.VIEW_MODE}
                    rows={2}
                    placeholder={t(
                      translationConstants.ENTER_COMPETITION_DESCRIPTION
                    )}
                    {...register("CompetitionInfo.Description", {
                      required: t(
                        translationConstants.COMPETITION_DESCRIPTION_REQUIRED
                      ),
                    })}
                  />
                  {errors?.CompetitionInfo?.Description && (
                    <p className="errorText">
                      {errors?.CompetitionInfo?.Description.message}
                    </p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  md={12}
                  label={
                    <>
                      {t(translationConstants.DESCRIPTION)}{" "}
                      {t(translationConstants.ARABIC_WITH_BRACES)}:
                      <span className="greenText">
                        {" "}
                        ({t(translationConstants.optional)})
                      </span>
                    </>
                  }
                >
                  <Form.Control
                    dir={Directions.rtl}
                    type="text"
                    id="CompetitionInfo.ArabicDescription"
                    as="textarea"
                    disabled={mode === modeConstants.VIEW_MODE}
                    rows={2}
                    placeholder={"أدخل الوصف باللغة العربية"}
                    {...register("CompetitionInfo.ArabicDescription", {})}
                  />
                  {errors?.CompetitionInfo?.ArabicDescription && (
                    <p className="errorText">
                      {errors?.CompetitionInfo?.ArabicDescription?.message}
                    </p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  sm={6}
                  label={
                    <>
                      {t(translationConstants.COMPETITION_TYPE)}:
                      {Mandatory_Character}
                    </>
                  }
                >
                  <Controller
                    name="CompetitionInfo.IsPublicRegistrationAllowed"
                    control={control}
                    disabled={mode === modeConstants.VIEW_MODE}
                    defaultValue={isPublicRegistrationAllowed}
                    rules={{
                      validate: (value) =>
                        value === true ||
                        value === false ||
                        t(translationConstants.COMPETITION_TYPE_REQUIRED),
                    }}
                    render={({ field }) => (
                      <>
                        <div className="d-flex">
                          <div className="me-5">
                            <Form.Check
                              type="radio"
                              id="privateCompetitionType"
                              label={t(translationConstants.PRIVATE)}
                              checked={field.value === false}
                              value={false}
                              onChange={() => {
                                setIsPublicRegistrationAllowed(false);
                                setValue(
                                  "CompetitionInfo.RegistrationFee",
                                  null
                                );
                                setValue(
                                  "CompetitionInfo.SpecialMemberFee",
                                  null
                                );
                                field.onChange(false);
                              }}
                            />
                          </div>
                          <Form.Check
                            type="radio"
                            id="publicCompetitionType"
                            label={t(translationConstants.PUBLIC)}
                            checked={field.value === true}
                            value={true}
                            onChange={() => {
                              setIsPublicRegistrationAllowed(true);
                              field.onChange(true);
                            }}
                          />
                        </div>
                        {errors?.CompetitionInfo
                          ?.IsPublicRegistrationAllowed && (
                          <p className="errorText">
                            {
                              errors?.CompetitionInfo
                                ?.IsPublicRegistrationAllowed?.message
                            }
                          </p>
                        )}
                      </>
                    )}
                  />
                </InputFieldWrapper>

                <InputFieldWrapper
                  sm={6}
                  label={
                    <>
                      {t(translationConstants.EXCLUSIVE_FOR_MEMBERS)}:
                      {Mandatory_Character}
                    </>
                  }
                >
                  <Controller
                    name="CompetitionInfo.IsMemebersExclusiveOnly"
                    control={control}
                    disabled={mode === modeConstants.VIEW_MODE}
                    defaultValue={isExclusiveForMembers}
                    rules={{
                      validate: (value) =>
                        value === true ||
                        value === false ||
                        t(
                          translationConstants.COMPETITION_EXCLUSIVE_MEMBERS_REQUIRED
                        ),
                    }}
                    render={({ field }) => (
                      <>
                        <div className="d-flex">
                          <div className="me-5">
                            <Form.Check
                              type="radio"
                              id="yesExclusive"
                              label={t(translationConstants.YES)}
                              checked={field.value === true}
                              value={true}
                              onChange={() => {
                                setIsExclusiveForMembers(true);
                                setValue(
                                  "CompetitionInfo.SpecialMemberFee",
                                  null
                                );
                                field.onChange(true);
                              }}
                            />
                          </div>
                          <Form.Check
                            type="radio"
                            id="noExclusive"
                            label={t(translationConstants.NO)}
                            checked={field.value === false}
                            value={false}
                            onChange={() => {
                              setIsExclusiveForMembers(false);
                              field.onChange(false);
                            }}
                          />
                        </div>
                        {errors?.CompetitionInfo?.IsMemebersExclusiveOnly && (
                          <p className="errorText">
                            {
                              errors?.CompetitionInfo?.IsMemebersExclusiveOnly
                                ?.message
                            }
                          </p>
                        )}
                      </>
                    )}
                  />
                </InputFieldWrapper>

                <InputFieldWrapper
                  lg={3}
                  label={
                    `${t(translationConstants.COMPETITION_START_DATE)}:` +
                    Mandatory_Character
                  }
                >
                  <Controller
                    name="CompetitionInfo.StartDateString"
                    control={control}
                    rules={{
                      required: t(
                        translationConstants.COMPETITION_START_DATE_REQUIRED
                      ),
                    }}
                    render={({ field }) => (
                      <ReactDatePickerWrapper
                        onChange={(date) => {
                          field.onChange(date);
                          if (mode === modeConstants.EDIT_MODE) {
                            setIsDateChanged(true);
                          }
                        }}
                        selected={field.value}
                        minDate={disableDates(true)}
                        value={field.value}
                        disabled={mode === modeConstants.VIEW_MODE}
                      />
                    )}
                  />
                  {errors?.CompetitionInfo?.StartDateString && (
                    <p className="errorText">
                      {errors?.CompetitionInfo?.StartDateString.message}
                    </p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  lg={3}
                  label={
                    `${t(translationConstants.COMPETITION_END_DATE)}:` +
                    Mandatory_Character
                  }
                >
                  <Controller
                    name="CompetitionInfo.EndDateString"
                    control={control}
                    rules={{
                      required: t(
                        translationConstants.COMPETITION_END_DATE_REQUIRED
                      ),
                      validate: {
                        isAfterStartDate: (value) => {
                          if (
                            isBefore(value, "CompetitionInfo.StartDateString")
                          ) {
                            return t(
                              translationConstants.COMPETITION_END_DATE_MUST_BE_AFTER_START_DATE
                            );
                          }
                        },
                      },
                    }}
                    render={({ field }) => (
                      <ReactDatePickerWrapper
                        onChange={(date) => {
                          field.onChange(date);
                          if (mode === modeConstants.EDIT_MODE) {
                            setIsDateChanged(true);
                          }
                        }}
                        selected={field.value}
                        minDate={disableDates(true)}
                        value={field.value}
                      />
                    )}
                  />
                  {errors?.CompetitionInfo?.EndDateString && (
                    <p className="errorText">
                      {errors?.CompetitionInfo?.EndDateString.message}
                    </p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  lg={3}
                  label={
                    `${t(translationConstants.CENTER_START_TIME)}:` +
                    Mandatory_Character
                  }
                >
                  <Controller
                    name="startTime"
                    control={control}
                    rules={{
                      required: t(
                        translationConstants.competition_start_time_is_required
                      ),
                    }}
                    render={({ field }) => (
                      <ReactDatePickerWrapper
                        onChange={(time) => {
                          field.onChange(time);
                        }}
                        isTimePicker={true}
                        selected={field.value}
                        value={field.value}
                        disabled={mode === modeConstants.VIEW_MODE}
                      />
                    )}
                  />
                  {errors?.startTime && (
                    <p className="errorText">{errors?.startTime.message}</p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  lg={3}
                  label={
                    <>
                      {`${t(translationConstants.CENTER_END_TIME)}: `}
                      <span className="greenText">
                        ({t(translationConstants.optional)})
                      </span>
                    </>
                  }
                >
                  <Controller
                    name="endTime"
                    control={control}
                    rules={{
                      validate: {
                        isCompetitionEndTimeAfterStartTimeIfSameDay:
                          isCompetitionEndTimeAfterStartTimeIfSameDay,
                      },
                    }}
                    render={({ field }) => (
                      <ReactDatePickerWrapper
                        onChange={(time) => {
                          field.onChange(time);
                        }}
                        isTimePicker={true}
                        selected={field.value}
                        value={field.value}
                        disabled={mode === modeConstants.VIEW_MODE}
                      />
                    )}
                  />
                  {errors?.endTime && (
                    <p className="errorText">{errors?.endTime.message}</p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  label={
                    `${t(translationConstants.REGISTRATION_START_DATE)}:` +
                    Mandatory_Character
                  }
                >
                  <Controller
                    name="CompetitionInfo.RegistrationStartDateString"
                    control={control}
                    rules={{
                      required: t(
                        translationConstants.COMPETITION_REGISTRATION_START_DATE_REQUIRED
                      ),
                      validate: {
                        isAfterStartDate: (value) => {
                          if (
                            isSameOrAfter(
                              value,
                              "CompetitionInfo.StartDateString"
                            )
                          ) {
                            return t(
                              translationConstants.REGISTRATION_START_DATE_MUST_BE_BEFORE_START_DATE
                            );
                          }
                        },
                      },
                    }}
                    render={({ field }) => (
                      <ReactDatePickerWrapper
                        onChange={(date) => {
                          field.onChange(date);
                          if (mode === modeConstants.EDIT_MODE) {
                            setIsDateChanged(true);
                          }
                        }}
                        selected={field.value}
                        minDate={disableDates(false)}
                        value={field.value}
                      />
                    )}
                  />
                  {errors?.CompetitionInfo?.RegistrationStartDateString && (
                    <p className="errorText">
                      {
                        errors?.CompetitionInfo?.RegistrationStartDateString
                          .message
                      }
                    </p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  label={
                    `${t(translationConstants.REGISTRATION_END_DATE)}: ` +
                    Mandatory_Character
                  }
                >
                  <Controller
                    name="CompetitionInfo.RegistrationEndDateString"
                    control={control}
                    rules={{
                      required: t(
                        translationConstants.COMPETITION_REGISTRATION_END_DATE_REQUIRED
                      ),
                      validate: {
                        isAfterStartDate: (value) => {
                          if (
                            isSameOrAfter(
                              value,
                              "CompetitionInfo.StartDateString"
                            )
                          ) {
                            return t(
                              translationConstants.REGISTRATION_END_DATE_MUST_BE_BEFORE_START_DATE
                            );
                          }
                        },
                        isBeforeRegistrationStartDate: (value) => {
                          if (
                            isBefore(
                              value,
                              "CompetitionInfo.RegistrationStartDateString"
                            )
                          ) {
                            return t(
                              translationConstants.REGISTRATION_END_DATE_MUST_BE_AFTER_REGISTRATION_START_DATE
                            );
                          }
                        },
                      },
                    }}
                    render={({ field }) => (
                      <ReactDatePickerWrapper
                        onChange={(date) => {
                          field.onChange(date);
                          if (mode === modeConstants.EDIT_MODE) {
                            setIsDateChanged(true);
                          }
                        }}
                        selected={field.value}
                        minDate={disableDates(false)}
                        value={field.value}
                      />
                    )}
                  />
                  {errors?.CompetitionInfo?.RegistrationEndDateString && (
                    <p className="errorText">
                      {
                        errors?.CompetitionInfo?.RegistrationEndDateString
                          .message
                      }
                    </p>
                  )}
                </InputFieldWrapper>

                <div className="activity-modal-timezone">
                  {t(translationConstants.TIMEZONE_DISPLAY_ON_GRID)}
                </div>

                <Col md={6} className="mb-3">
                  <div className="d-flex gap-2 flex-wrap">
                    <Form.Label className="Form-labels">
                      {t(translationConstants.LOCATION) + Mandatory_Character}
                    </Form.Label>
                    <div className="d-flex flex-wrap">
                      <Form.Check
                        className="mt-negative-10 small-checkbox me-2"
                        type="checkbox"
                        checked={
                          selectedSpotType ===
                          LocationSelectionConstants.PUBLIC_SPOT
                        }
                        label={t(translationConstants.PUBLIC_SPOT)}
                        onChange={() => {
                          handleLocationCheckboxChange(
                            LocationSelectionConstants.PUBLIC_SPOT
                          );
                          setIsLocationChanged(true);
                          setValue("CompetitionInfo.Lat", null);
                          setValue("CompetitionInfo.Long", null);
                          setValue("CompetitionInfo.SpotId", null);
                          setValue("CompetitionInfo.LocationURL", null);
                        }}
                      />
                      <Form.Check
                        className="mt-negative-10 small-checkbox me-2"
                        type="checkbox"
                        checked={
                          selectedSpotType ===
                          LocationSelectionConstants.PRIVATE_SPOT
                        }
                        label={t(translationConstants.PRIVATE_SPOT)}
                        onChange={() => {
                          handleLocationCheckboxChange(
                            LocationSelectionConstants.PRIVATE_SPOT
                          );
                          setIsLocationChanged(true);
                          setValue("CompetitionInfo.Lat", null);
                          setValue("CompetitionInfo.Long", null);
                          setValue("CompetitionInfo.SpotId", null);
                          setValue("CompetitionInfo.LocationURL", null);
                        }}
                      />
                      <Form.Check
                        className="mt-negative-10 small-checkbox me-2"
                        type="checkbox"
                        checked={
                          selectedSpotType ===
                          LocationSelectionConstants.CUSTOM_LOCATION
                        }
                        label={t(translationConstants.custom_location)}
                        onChange={() => {
                          handleLocationCheckboxChange(
                            LocationSelectionConstants.CUSTOM_LOCATION
                          );
                          setIsLocationChanged(true);
                          setValue("CompetitionInfo.SpotId", null);
                          setValue("CompetitionInfo.LocationURL", null);
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    {selectedSpotType ===
                      LocationSelectionConstants.PUBLIC_SPOT && (
                      <>
                        <Form.Select
                          id="CompetitionInfo.SpotId"
                          {...register("CompetitionInfo.SpotId", {
                            required:
                              selectedSpotType ===
                                LocationSelectionConstants.PUBLIC_SPOT &&
                              t(
                                translationConstants.CENTER_ACTIVITY_LOCATION_REQUIRED
                              ),
                          })}
                          onChange={(e) => {
                            handleLocationChange(e);
                            setIsLocationChanged(true);
                          }}
                        >
                          <option value="">
                            {t(translationConstants.SELECT_PUBLIC_SPOT)}
                          </option>
                          {getFilteredSpotsOptions(
                            spotConstants.spotType.PUBLIC
                          )}
                        </Form.Select>
                        {errors?.CompetitionInfo?.SpotId && (
                          <p className="errorText">
                            {errors?.CompetitionInfo.SpotId.message}
                          </p>
                        )}
                      </>
                    )}
                    {selectedSpotType ===
                      LocationSelectionConstants.PRIVATE_SPOT && (
                      <>
                        <Form.Select
                          id="CompetitionInfo.SpotId"
                          {...register("CompetitionInfo.SpotId", {
                            required:
                              selectedSpotType ===
                                LocationSelectionConstants.PRIVATE_SPOT &&
                              t(
                                translationConstants.CENTER_ACTIVITY_LOCATION_REQUIRED
                              ),
                          })}
                          onChange={(e) => {
                            handleLocationChange(e);
                            setIsLocationChanged(true);
                          }}
                        >
                          <option value="">
                            {t(translationConstants.SELECT_PRIVATE_SPOT)}
                          </option>
                          {getFilteredSpotsOptions(
                            spotConstants.spotType.PRIVATE
                          )}
                        </Form.Select>
                        {errors?.CompetitionInfo?.SpotId && (
                          <p className="errorText">
                            {errors?.CompetitionInfo.SpotId.message}
                          </p>
                        )}
                      </>
                    )}
                    {selectedSpotType ===
                      LocationSelectionConstants.CUSTOM_LOCATION && (
                      <>
                        <Form.Select
                          id="CompetitionInfo.CityId"
                          {...register("CompetitionInfo.CityId", {
                            required:
                              selectedSpotType ===
                                LocationSelectionConstants.CUSTOM_LOCATION &&
                              t(translationConstants.CITY_IS_REQUIRED),
                          })}
                          onChange={() => {
                            setIsLocationChanged(true);
                          }}
                        >
                          <option value="">
                            {t(translationConstants.SELECT_A_CITY)}
                          </option>
                          {cities?.map((city) => (
                            <option key={city.id} value={city.id}>
                              {direction === Directions.rtl
                                ? city?.arabicName || city?.name
                                : city?.name}
                            </option>
                          ))}
                        </Form.Select>
                        {errors?.CompetitionInfo?.CityId && (
                          <p className="errorText">
                            {errors?.CompetitionInfo?.CityId.message}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </Col>

                {selectedSpotType ===
                LocationSelectionConstants.CUSTOM_LOCATION ? (
                  <Col md={6}>
                    <div>
                      <Form.Label className="Form-labels">
                        {`${t(translationConstants.SPOT_COORDINATES)}:` +
                          Mandatory_Character}
                      </Form.Label>
                      <div className="row">
                        <div className="d-flex justify-content-start gap-2 col-md-7 col-12">
                          <Form.Group className="">
                            <Form.Control
                              id="CompetitionInfo.Lat"
                              type="text"
                              disabled={
                                selectedSpotType !==
                                LocationSelectionConstants.CUSTOM_LOCATION
                              }
                              onChange={(e) => {
                                setIsLocationChanged(true);
                              }}
                              {...register("CompetitionInfo.Lat", {
                                required:
                                  selectedSpotType ===
                                    LocationSelectionConstants.CUSTOM_LOCATION &&
                                  t(translationConstants.LAT_REQUIRED),
                                pattern: {
                                  value: /^-?([1-8]?[0-9](\.\d+)?|90(\.0+)?)$/,
                                  message: t(
                                    translationConstants.LAT_RANGE_VALIDATION_TEXT
                                  ),
                                },
                              })}
                            />
                            {errors.CompetitionInfo?.Lat && (
                              <p className="errorText">
                                {errors.CompetitionInfo?.Lat.message}
                              </p>
                            )}
                          </Form.Group>
                          <Form.Group className="">
                            <Form.Control
                              id="CompetitionInfo.Long"
                              type="text"
                              disabled={
                                selectedSpotType !==
                                LocationSelectionConstants.CUSTOM_LOCATION
                              }
                              {...register("CompetitionInfo.Long", {
                                required:
                                  selectedSpotType ===
                                    LocationSelectionConstants.CUSTOM_LOCATION &&
                                  t(translationConstants.LNG_REQUIRED),
                                pattern: {
                                  value:
                                    /^-?((([1-9]?[0-9]|1[0-7][0-9])(\.\d+)?)|180(\.0+)?)$/,
                                  message: t(
                                    translationConstants.LNG_RANGE_VALIDATION_TEXT
                                  ),
                                },
                              })}
                            />
                            {errors.CompetitionInfo?.Long && (
                              <p className="errorText">
                                {errors.CompetitionInfo.Long.message}
                              </p>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-12 col-md-5">
                          <Form.Group className="d-flex justify-content-between">
                            <Button
                              disabled={
                                selectedSpotType !==
                                LocationSelectionConstants.CUSTOM_LOCATION
                              }
                              className="find-on-map-button back-none my-md-auto my-3 d-md-flex d-block "
                              type="button"
                              onClick={onSetShowMap}
                            >
                              {t(translationConstants.FIND_ON_MAP)}
                            </Button>
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                  </Col>
                ) : (
                  <InputFieldWrapper
                    label={
                      `${t(translationConstants.LOCATION_LINK)}:` +
                      Mandatory_Character
                    }
                  >
                    <Form.Control
                      type="text"
                      id="CompetitionInfo.LocationURL"
                      disabled={true}
                      {...register("CompetitionInfo.LocationURL", {})}
                    />
                    {errors?.CompetitionInfo?.LocationURL && (
                      <p className="errorText">
                        {errors?.CompetitionInfo?.LocationURL.message}
                      </p>
                    )}
                  </InputFieldWrapper>
                )}

                <InputFieldWrapper
                  label={
                    `${t(translationConstants.USER_ALLOWED)}:` +
                    Mandatory_Character
                  }
                >
                  <div className="d-flex ga-2 flex-wrap">
                    {competitionAllowedUsers(t).map((option, index) => (
                      <Form.Group
                        key={index}
                        className="px-2"
                        controlId={option.value}
                      >
                        <Form.Check
                          className="offer"
                          type="checkbox"
                          value={option.value}
                          label={<p>{option.label}</p>}
                          {...register(`userAllowed`, {
                            validate: {
                              atLeastOne: (value) =>
                                value.length > 0 ||
                                t(
                                  translationConstants.COMPETITON_REQUIRES_ATLEAST_ONE_USER_IS_REQUIRED
                                ),
                            },
                          })}
                        />
                      </Form.Group>
                    ))}
                  </div>
                  {errors?.userAllowed && (
                    <p className="errorText">{errors?.userAllowed?.message}</p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  label={
                    `${t(translationConstants.gender)}:` + Mandatory_Character
                  }
                >
                  <Form.Select
                    id="CompetitionInfo.Gender"
                    {...register("CompetitionInfo.Gender", {
                      required: t(translationConstants.genderSelectionRequired),
                    })}
                  >
                    <option value="">
                      {t(translationConstants.selectGender)}
                    </option>
                    {genderOptions(t)?.map((object) => {
                      return (
                        <option key={object.value} value={object.value}>
                          {object.label}
                        </option>
                      );
                    })}
                  </Form.Select>
                  {errors?.CompetitionInfo?.Gender && (
                    <p className="errorText">
                      {errors?.CompetitionInfo?.Gender?.message}
                    </p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  label={
                    `${t(translationConstants.SPORT_TYPE)}:` +
                    Mandatory_Character
                  }
                >
                  <Form.Select
                    id="CompetitionInfo.SportId"
                    {...register("CompetitionInfo.SportId", {
                      required: t(
                        translationConstants.COMPETITION_SPORT_TYPE_REQUIRED
                      ),
                    })}
                  >
                    <option value="">
                      {t(translationConstants.SELECT_SPORT_TYPE)}
                    </option>
                    {Object.entries(sportConstants).map(([sport, value]) => (
                      <option key={value} value={value}>
                        {t(translationConstants[sport])}
                      </option>
                    ))}
                  </Form.Select>
                  {errors?.CompetitionInfo?.SportId && (
                    <p className="errorText">
                      {errors?.CompetitionInfo?.SportId.message}
                    </p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  label={
                    `${t(translationConstants.SUGGESTED_LEVEL)}:` +
                    Mandatory_Character
                  }
                >
                  <Form.Select
                    id="CompetitionInfo.AllowedLevel"
                    {...register("CompetitionInfo.AllowedLevel", {
                      required: t(
                        translationConstants.COMPETITION_SUGGESTED_LEVEL_REQUIRED
                      ),
                    })}
                  >
                    <option value="">
                      {t(
                        translationConstants.SELECT_COMPETITION_SUGGESTED_LEVEL
                      )}
                    </option>
                    {Object.values(levelEnum)
                      .filter((value) => value !== levelEnum.GENERAL_TRAINING)
                      .map((value) => (
                        <option key={value} value={value}>
                          {t(translationConstants[levelEnumReversed[value]])}
                        </option>
                      ))}
                  </Form.Select>
                  {errors?.CompetitionInfo?.AllowedLevel && (
                    <p className="errorText">
                      {errors?.CompetitionInfo?.AllowedLevel.message}
                    </p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  sm={12}
                  md={12}
                  lg={12}
                  label={
                    `${t(translationConstants.BOAT_CLASSES)}:` +
                    Mandatory_Character
                  }
                >
                  <Controller
                    control={control}
                    name="Classes"
                    rules={{
                      required: t(
                        translationConstants.COMPETITION_BOAT_CLASSES_REQUIRED
                      ),
                    }}
                    render={({ field }) => (
                      <MultiSelect
                        id="Classes"
                        isMulti
                        options={filteredOptions}
                        value={selectedOptions}
                        placeholder={t(
                          translationConstants.SELECT_BOAT_CLASSES
                        )}
                        onChange={(val) => {
                          setSelectedOptions(val);
                          field.onChange(val?.map((item) => item.value));
                          trigger("Classes");
                        }}
                      />
                    )}
                  />
                  {errors?.Classes && (
                    <p className="errorText">{errors?.Classes.message}</p>
                  )}
                </InputFieldWrapper>

                {isPublicRegistrationAllowed && (
                  <>
                    <InputFieldWrapper
                      label={
                        <>
                          {t(translationConstants.REGISTRATION_FEES)}:
                          {Mandatory_Character}{" "}
                          <span className="greenText">
                            {t(translationConstants.SAR_WITH_BRACES)}
                          </span>{" "}
                          {t(translationConstants.VAT)}{" "}
                          {t(translationConstants.EXCLUDED)}
                        </>
                      }
                    >
                      <Form.Group>
                        <div className="d-flex radio-button mt-0">
                          <Form.Check
                            inline
                            type="radio"
                            id="inline-radio-yes"
                            label={t(translationConstants.YES)}
                            value={true}
                            checked={isRegistrationFees === true}
                            onChange={() => {
                              setIsRegistrationFees(true);
                            }}
                          />
                          <Form.Check
                            inline
                            label={t(translationConstants.NO)}
                            type="radio"
                            id="inline-radio-no"
                            value={false}
                            checked={isRegistrationFees === false}
                            onChange={() => {
                              setIsRegistrationFees(false);
                              setValue("CompetitionInfo.RegistrationFee", null);
                              setValue(
                                "CompetitionInfo.SpecialMemberFee",
                                null
                              );
                            }}
                          />
                          <Form.Control
                            type="number"
                            id="CompetitionInfo.RegistrationFee"
                            disabled={!isRegistrationFees}
                            placeholder={t(
                              translationConstants.ENTER_COMPETITION_REGISTRATION_FEE
                            )}
                            {...register("CompetitionInfo.RegistrationFee", {
                              min: {
                                value: 1,
                                message: t(
                                  translationConstants.MINIMUM_VALUE_SHOULD_BE_1
                                ),
                              },
                              required:
                                isRegistrationFees &&
                                t(
                                  translationConstants.COMPETITION_REGISTRATION_FEE_REQUIRED
                                ),
                            })}
                          />
                        </div>
                        {isRegistrationFees &&
                          errors.CompetitionInfo?.RegistrationFee && (
                            <p className="errorText">
                              {errors.CompetitionInfo?.RegistrationFee.message}
                            </p>
                          )}
                      </Form.Group>
                    </InputFieldWrapper>

                    {!isExclusiveForMembers && (
                      <Col md={6}>
                        <div className="d-flex align-items-center gap-3">
                          <Form.Label className="Form-labels">
                            {t(translationConstants.SPECIAL_FEES_FOR_MEMBERS)}:{" "}
                            <span className="greenText">
                              {t(translationConstants.SAR_WITH_BRACES)}
                            </span>{" "}
                            {t(translationConstants.VAT)}{" "}
                            {t(translationConstants.EXCLUDED)}
                          </Form.Label>
                          <Form.Check
                            className="mt-negative-10"
                            type="checkbox"
                            checked={isSpecialMemberFeeEnable}
                            label={t(translationConstants.ENABLE)}
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              setIsSpecialMemberFeeEnable(isChecked);
                              if (!isChecked) {
                                setValue(
                                  "CompetitionInfo.SpecialMemberFee",
                                  null
                                );
                              }
                            }}
                            disabled={!isRegistrationFees}
                          />
                        </div>
                        <div className="mb-3">
                          <Form.Control
                            type="number"
                            id="CompetitionInfo.SpecialMemberFee"
                            disabled={
                              !isRegistrationFees || !isSpecialMemberFeeEnable
                            }
                            placeholder={t(
                              translationConstants.ENTER_COMPETITION_SPECIAL_FEES_FOR_MEMBERS
                            )}
                            {...register("CompetitionInfo.SpecialMemberFee", {
                              min: {
                                value: 1,
                                message: t(
                                  translationConstants.MINIMUM_VALUE_SHOULD_BE_1
                                ),
                              },
                              required:
                                isRegistrationFees &&
                                isSpecialMemberFeeEnable &&
                                t(
                                  translationConstants.COMPETITION_SPECIAL_FEE_REQUIRED
                                ),
                              validate: (value) => {
                                const fee = parseInt(
                                  getValues("CompetitionInfo.RegistrationFee")
                                );
                                if (value > fee) {
                                  return t(
                                    translationConstants.COMPETITION_SPECIAL_FEE_VALIDATION
                                  );
                                }
                              },
                            })}
                          />
                          {isRegistrationFees &&
                            isSpecialMemberFeeEnable &&
                            errors?.CompetitionInfo?.SpecialMemberFee && (
                              <p className="errorText">
                                {
                                  errors.CompetitionInfo?.SpecialMemberFee
                                    .message
                                }
                              </p>
                            )}
                        </div>
                      </Col>
                    )}
                  </>
                )}

                <InputFieldWrapper
                  label={
                    <>
                      {t(translationConstants.MINIMUM_AGE)}:
                      {Mandatory_Character}
                    </>
                  }
                >
                  <Form.Control
                    id="CompetitionInfo.MinAge"
                    type="number"
                    placeholder={t(
                      translationConstants.ENTER_COMPETITION_MIN_AGE
                    )}
                    {...register("CompetitionInfo.MinAge", {
                      required: t(
                        translationConstants.COMPETITION_MIN_AGE_REQUIRED
                      ),
                      min: {
                        value: 1,
                        message: t(
                          translationConstants.MINIMUM_VALUE_SHOULD_BE_1
                        ),
                      },
                    })}
                  />
                  {errors?.CompetitionInfo?.MinAge && (
                    <p className="errorText">
                      {errors?.CompetitionInfo?.MinAge.message}
                    </p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  label={
                    <>
                      {t(translationConstants.MAXIMUM_AGE)}:
                      {Mandatory_Character}
                    </>
                  }
                >
                  <Form.Control
                    id="CompetitionInfo.MaxAge"
                    type="number"
                    placeholder={t(
                      translationConstants.ENTER_COMPETITION_MAX_AGE
                    )}
                    {...register("CompetitionInfo.MaxAge", {
                      required: t(
                        translationConstants.COMPETITION_MAX_AGE_REQUIRED
                      ),
                      validate: (value) => {
                        const minValue = parseInt(
                          getValues("CompetitionInfo.MinAge")
                        );
                        if (!minValue || value >= minValue) {
                          return true;
                        }
                        return t(
                          translationConstants.COMPETITION_MAX_AGE_VALIDATION
                        );
                      },
                    })}
                  />
                  {errors?.CompetitionInfo?.MaxAge && (
                    <p className="errorText">
                      {errors?.CompetitionInfo?.MaxAge.message}
                    </p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  label={
                    `${t(translationConstants.COMPETITION_MAX_PARTICIPANT)}:` +
                    Mandatory_Character
                  }
                >
                  <Form.Control
                    type="number"
                    id="CompetitionInfo.MaximumParticipantsAllowed"
                    disabled={mode === modeConstants.VIEW_MODE}
                    placeholder={t(
                      translationConstants.COMPETITION_MAX_PARTICIPANTS_ALLOWED
                    )}
                    {...register("CompetitionInfo.MaximumParticipantsAllowed", {
                      required: t(
                        translationConstants.COMPETITION_MAX_PARTICIPANTS_REQUIRED
                      ),
                      max: {
                        value: fieldLengthConstants.NUMBER_FIELD_VALUE,
                        message: t(
                          translationConstants.COMPETITION_MAX_PARTICIPANTS_MAX_LIMIT
                        ),
                      },
                      min: {
                        value: 1,
                        message: t(
                          translationConstants.MAXIMUM_PARTICIPANTS_MUST_BE_GREATER_THAN_0
                        ),
                      },
                    })}
                  />
                  {errors?.CompetitionInfo?.MaximumParticipantsAllowed && (
                    <p className="errorText">
                      {
                        errors?.CompetitionInfo?.MaximumParticipantsAllowed
                          ?.message
                      }
                    </p>
                  )}
                </InputFieldWrapper>

                <InputFieldWrapper
                  label={<>{t(translationConstants.SERVICES_INCLUDED)}:</>}
                >
                  <div className="d-flex flex-wrap">
                    {Object.keys(competitionProvidedServices).map((id) => (
                      <Form.Group key={id} controlId={id}>
                        <Form.Check
                          className="flex-grow-1"
                          type="checkbox"
                          label={t(translationConstants[id])}
                          {...register(id.toLowerCase())}
                          disabled={mode === modeConstants.VIEW_MODE}
                          checked={selectedServices[id]}
                          onChange={() => handleCheckboxChange(id)}
                        />
                      </Form.Group>
                    ))}
                  </div>
                </InputFieldWrapper>

                <InputFieldWrapper
                  lg={6}
                  md={12}
                  label={
                    <>
                      {t(translationConstants.UPLOAD_NOR)}:{Mandatory_Character}
                    </>
                  }
                >
                  <div className="filterUploader">
                    <FileUploader
                      sm
                      single
                      customColor="file-uploader-color"
                      disabled={mode === modeConstants.VIEW_MODE}
                      defaultValue={nor}
                      {...register("nor", {
                        required:
                          mode === modeConstants.ADD_MODE
                            ? t(translationConstants.COMPETITION_NOR_REQUIRED)
                            : nor.length < 1 &&
                              t(translationConstants.COMPETITION_NOR_REQUIRED),
                      })}
                      onFileUpload={(file) => handleFileUpload(file, "nor")}
                      setValidationErrorMessage={setNORValidationMessage}
                      onChangeFlag={setIsNorUpdated}
                      isError={errors.nor || norValidationMessage}
                      isAllowPreview={mode === modeConstants.VIEW_MODE}
                      onFileRemove={() => {
                        setNor([]);
                      }}
                    />
                    {errors.nor && !norValidationMessage && (
                      <p className="errorText">{errors.nor?.message}</p>
                    )}
                    {norValidationMessage && (
                      <p className="errorText">{norValidationMessage}</p>
                    )}
                  </div>
                </InputFieldWrapper>

                <InputFieldWrapper
                  lg={6}
                  md={12}
                  label={
                    <>
                      {t(translationConstants.UPLOAD_COMPETITION_POSTER)}:
                      {Mandatory_Character}
                    </>
                  }
                >
                  <div className="filterUploader">
                    <FileUploader
                      sm
                      single
                      customColor="file-uploader-color"
                      isImage
                      defaultValue={posters}
                      {...register("posters", {
                        required:
                          mode === modeConstants.ADD_MODE
                            ? t(
                                translationConstants.COMPETITION_POSTERS_REQUIRED
                              )
                            : posters.length < 1 &&
                              t(
                                translationConstants.COMPETITION_POSTERS_REQUIRED
                              ),
                      })}
                      onFileUpload={(file) => handleFileUpload(file, "posters")}
                      setValidationErrorMessage={setPostersValidationMessage}
                      onChangeFlag={setIsPostersUpdated}
                      isError={errors.posters || postersValidationMessage}
                      isAllowPreview={mode === modeConstants.VIEW_MODE}
                      onFileRemove={() => {
                        setPosters([]);
                      }}
                    />
                    <p className="RecommendationText">
                      {t(translationConstants.POSTER_RECOMMENDED_SIZE)}
                    </p>

                    {errors.posters && !postersValidationMessage && (
                      <p className="errorText">{errors.posters?.message}</p>
                    )}
                    {postersValidationMessage && (
                      <p className="errorText">{postersValidationMessage}</p>
                    )}
                  </div>
                </InputFieldWrapper>

                <InputFieldWrapper
                  lg={6}
                  md={12}
                  label={
                    <>
                      {t(translationConstants.UPLOAD_COMPETITION_LOGO)}:
                      {Mandatory_Character}
                    </>
                  }
                >
                  <div className="filterUploader">
                    <FileUploader
                      sm
                      single
                      customColor="file-uploader-color"
                      isImage
                      defaultValue={logo}
                      {...register("logo", {
                        required:
                          mode === modeConstants.ADD_MODE
                            ? t(translationConstants.COMPETITION_LOGO_REQUIRED)
                            : logo.length < 1 &&
                              t(translationConstants.COMPETITION_LOGO_REQUIRED),
                      })}
                      onFileUpload={(file) => handleFileUpload(file, "logo")}
                      setValidationErrorMessage={setLogoValidationMessage}
                      onChangeFlag={setIsLogoUpdated}
                      isError={errors.logo || logoValidationMessage}
                      isAllowPreview={mode === modeConstants.VIEW_MODE}
                      onFileRemove={() => {
                        setLogo([]);
                      }}
                    />
                    {errors.logo && !logoValidationMessage && (
                      <p className="errorText">{errors.logo?.message}</p>
                    )}
                    {logoValidationMessage && (
                      <p className="errorText">{logoValidationMessage}</p>
                    )}
                  </div>
                </InputFieldWrapper>
              </Row>

              {mode === modeConstants.EDIT_MODE ? (
                <Row className="d-flex justify-content-center mt-2 mx-lg-5">
                  {competitionDataById?.competitionInfo?.status ===
                  competitionsStatusEnum.PUBLISHED ? (
                    <Col className="mx-1 d-flex justify-content-center">
                      <Button
                        id={competitionConstants.UNPUBLISH_BUTTON}
                        className="btn-submit-outline mb-2"
                        onClick={() => {
                          dispatch(
                            competitionActions.updateCompetitionStatusById(
                              competitionDataById?.id,
                              competitionsStatusEnum.UNPUBLISHED,
                              backToCompetition
                            )
                          );
                        }}
                      >
                        {t(translationConstants.UNPUBLISH)}
                      </Button>
                    </Col>
                  ) : (
                    <Col className="mx-1 d-flex justify-content-center">
                      <Button
                        id={competitionConstants.PUBLISH_BUTTON}
                        className="btn-submit mb-2"
                        onClick={() => {
                          dispatch(
                            competitionActions.updateCompetitionStatusById(
                              competitionDataById?.id,
                              competitionsStatusEnum.PUBLISHED,
                              backToCompetition
                            )
                          );
                        }}
                      >
                        {t(translationConstants.PUBLISH)}
                      </Button>
                    </Col>
                  )}
                  <Col className="mx-1 d-flex justify-content-center">
                    <Button
                      id={competitionConstants.UPDATE_BUTTON}
                      className="btn-submit mb-2"
                      type="submit"
                    >
                      {t(translationConstants.Update)}
                    </Button>
                  </Col>
                  <Col className="mx-1 d-flex justify-content-center">
                    <Button
                      className="reject-button m-0"
                      type="button"
                      onClick={() => backToCompetition()}
                    >
                      {t(translationConstants.cancel)}
                    </Button>
                  </Col>
                </Row>
              ) : mode === modeConstants.ADD_MODE ? (
                <Row className="d-flex justify-content-center mt-2 mx-lg-5">
                  <Col className="mx-1 d-flex justify-content-center">
                    <Button
                      id={competitionConstants.ADD_BUTTON}
                      className="btn-submit mb-2"
                      type="submit"
                    >
                      {t(translationConstants.CREATE_AND_PUBLISH)}
                    </Button>
                  </Col>
                  <Col className="mx-1 d-flex justify-content-center">
                    <Button
                      id={competitionConstants.DRAFT_BUTTON}
                      className="btn-submit mb-2"
                      type="submit"
                    >
                      {t(translationConstants.SAVE_DRAFT)}
                    </Button>
                  </Col>
                  <Col className="mx-1 d-flex justify-content-center">
                    <Button
                      className="reject-button m-0"
                      type="button"
                      onClick={() => backToCompetition()}
                    >
                      {t(translationConstants.cancel)}
                    </Button>
                  </Col>
                </Row>
              ) : (
                ""
              )}
            </Container>
          </Form>
        </Col>
      </Row>

      <CustomModal
        scrollable={true}
        size="md"
        setShow={dateLocationHandler}
        show={isModalOpen}
        customClass="view-user-modal"
      >
        <ConfirmationModal
          title={title}
          messageLine1={messageLine1}
          messageLine2={messageLine2}
          onCancel={() => setModalOpen(!isModalOpen)}
          onSubmit={() => {
            onSubmit(modalData, modalEvent);
            setModalOpen(!isModalOpen);
          }}
        />
      </CustomModal>

      <CustomModal
        size="lg"
        scrollable={true}
        setShow={onSetShowMap}
        show={isShowMap}
      >
        <FindOnMapModal
          setLng={setLng}
          setLat={setLat}
          lat={lat}
          lng={lng}
          handleSubmitLocation={handleSaveLocation}
        />
      </CustomModal>
    </div>
  );
};

export default AddCompetitions;
